import Image from 'next/image';
import { Markdown } from '@copilotkit/react-ui';

// Constants
import { IMAGES } from '@/constants';

// Utils
import { combineClasses } from '@shared/utils';
interface ChatbotResponseProps {
  msg: {
    content?: string | null;
  };
  className?: string;
}
export const ChatbotResponse = ({
  msg,
  className
}: ChatbotResponseProps) => <div className={combineClasses('flex flex-col items-start px-4 py-1', className)} data-sentry-component="ChatbotResponse" data-sentry-source-file="ChatbotResponse.tsx">
    <div className="flex items-center gap-2 border border-frost-250 rounded-lg shadow-md p-4 relative overflow-hidden w-full">
      <div className="flex-shrink-0 relative size-10 self-baseline">
        <div className={combineClasses('size-10 rounded-full flex-center relative m-auto', 'bg-gradient-to-br from-primary-50 to-primary-100 ')}>
          <Image unoptimized src={IMAGES.CHATBOT_PROCESSING} alt="Agility Flash" width={28} height={28} className="size-7 object-contain" data-sentry-element="Image" data-sentry-source-file="ChatbotResponse.tsx" />
        </div>
      </div>
      <div className="flex-1 min-w-0 text-3xs leading-relaxed break-words text-gray-500 marker:text-gray-500">
        <Markdown content={msg?.content || ''} data-sentry-element="Markdown" data-sentry-source-file="ChatbotResponse.tsx" />
      </div>
    </div>
  </div>;